import React from "react";
import zonkeEnergyTCs from "../../utils/zonkeTCs";

const TermsAndConditionsPage = () => {
  return (
    <div className="page-container">
      <div dangerouslySetInnerHTML={{ __html: zonkeEnergyTCs }} />
    </div>
  );
};

export default TermsAndConditionsPage;
